import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap'
import userImage from '../../../assets/images/fallandi/149071.png'
import navLinks from '../../../api/NavLinks';
import { logoutUser } from "../../../utils/API";
import { Link, NavLink, useHistory, useLocation, useParams } from 'react-router-dom';

const TopHeader = () => {
    const [dropdownOpen, setDropdownOpen] = React.useState(false);
    const [keepDropdownOpen, setKeepDropdownOpen] = React.useState(false);
    const history = useHistory()
    const { pathname } = useLocation()
    const { form_name } = useParams();
    const title = useSelector((state) => state.updatePageHeader.header_title)
    const toggle = () => setDropdownOpen(prevState => keepDropdownOpen ? keepDropdownOpen : !prevState);

    const AdminNavMenu = [
        { path: '/admin/users', label: 'Users' },
        { path: '/admin/connections', label: 'Connections' },
        { path: '/admin/monitoring', label: 'Monitoring' },
        { path: '/admin/licence', label: 'Licence' },
    ]

    const formNameNavMenu = [
        { path: `/form/${form_name}/documents`, label: 'Documents' },
        { path: `/form/${form_name}/drafts`, label: 'Brouillons' },
    ]

    const logout = () => {
        logoutUser();
    }


    const themes = ["Snow blue", "Air force blue", "Dark murrey", "Light sky blue"]
    const [currentTheme, setCurrentTheme] = useState("")

    useEffect(() => {
        let theme = localStorage.getItem('theme');
        if (theme) setCurrentTheme(theme);
    }, [])

    const handleThemeChange = (e) => {
        let theme = e.target.value
        document.documentElement.setAttribute('data-theme', theme);
        localStorage.setItem('theme');
        setCurrentTheme(theme)
    }

    return (
        <div>
            <div className="top_header">
                <div className="left-header">
                    <h5>{title}</h5>
                    <div className="d-flex left-header-wrap">
                        {pathname.includes('/admin/') && <>
                            {AdminNavMenu?.map((navItem) => (
                                <NavLink
                                    key={navItem?.path}
                                    to={navItem?.path}
                                >
                                    {navItem?.label}
                                </NavLink >
                            ))}
                        </>}
                        {(pathname.includes('/form/') || pathname.includes('/recycledocs')) && <>
                            {formNameNavMenu?.map((navItem) => (
                                <NavLink
                                    key={navItem?.path}
                                    to={navItem?.path}
                                >
                                    {navItem?.label}
                                </NavLink >
                            ))}
                            <div className='dropdown-wrap-outer'>
                                <div className='dropdown-wrap btns custom-buttons-options'>
                                    <label
                                        onClick={() => history.push("/form/" + form_name + "/form-archive")}
                                        className={pathname === "/form/" + form_name + "/form-archive" ? 'btn-defult active' : 'btn-defult'}
                                        htmlFor="dropdown-box-input"
                                        data-toggle="dropdown-box-outer"
                                    >
                                        Archivage
                                    </label>
                                    <label
                                        className={pathname === `/recycledocs2/${form_name}` ? 'btn-defult active' : 'btn-defult'}
                                        htmlFor="dropdown-box-input"
                                        data-toggle="dropdown-box-outer"
                                        onClick={() => history.push(`/recycledocs2/${form_name}`)}
                                    >
                                        Création documents
                                    </label>
                                    <label
                                        onClick={() => history.push("/form/" + form_name + "/create-object")}
                                        className={pathname === "/form/" + form_name + "/create-object" ? 'btn-defult active' : 'btn-defult'}
                                        htmlFor="dropdown-box-input"
                                        data-toggle="dropdown-box-outer"
                                    >
                                        Insertion données
                                    </label>
                                </div>
                            </div>
                        </>}

                    </div>
                </div>
                <UncontrolledDropdown isOpen={dropdownOpen} toggle={toggle} className="user-dropdown">
                    <DropdownToggle nav caret className="flex items-center gap-1">
                        <img src={userImage} className="w-10 mx-auto" />
                        <span className="">{localStorage.getItem("user")}</span>
                    </DropdownToggle>
                    <DropdownMenu className="childsubmenu dropdown-menu-right" right>
                        <DropdownItem onClick={logout}>Signout</DropdownItem>
                        <DropdownItem tag={Link} to="/change-password">Changer mot de passe</DropdownItem>
                        {
                        <DropdownItem
                            onMouseEnter={() => setKeepDropdownOpen(true)}
                            onMouseLeave={() => setKeepDropdownOpen(false)}
                        >
                            Change Theme
                            <div className='theme-changer'>
                                {keepDropdownOpen &&
                                    <select value={currentTheme} onChange={handleThemeChange}>
                                        {
                                            themes.map((item, index) => (
                                                <option value={item} key={index}>{item}</option>
                                            ))
                                        }
                                    </select>
                                }
                            </div>
                        </DropdownItem>}
                    </DropdownMenu>
                </UncontrolledDropdown>

            </div>
        </div>
    );
}

export default TopHeader;
